export default __webpack_public_path__ + "static/media/img_baseCrochet_lemon_p.9470af54.jpg";